import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SingleSocialsPage.css";

const images = [
  "assests/images/swiping-1.jpg",
  "assests/images/swiping-2.jpg",
  "assests/images/swiping-3.jpg",
  "assests/images/swiping-4.jpg",
  "assests/images/swiping-5.jpg",
  "assests/images/swiping-6.jpg",
];

const SingleSocialsPage = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: "13%",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0",
        },
      },
    ],
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    document.title = `YFMF Singles Events Ireland `;
    document.getElementById("bodywrap").className = "speedys";

    const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", "Join our large singles parties across Ireland. Great venues, great energy, and a chance to meet someone new — no pressure, just fun.");
      } 

  }, []);

  return (
    <>
      <Header />

      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + "assests/images/sin-d.jpg"}
          alt="QR Code"
          className="img-fluid d-none d-md-block"
        />

        {/* Mobile Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + "assests/images/sin-m.jpg"}
          alt="QR Code"
          className="img-fluid d-block d-md-none"
        />
      </div>

      <div className="container-fluid ireland">
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>SINGLES SOCIALS</p>
            <h2>Ireland’s Largest Singles Nights</h2>
          </div>

          <div className="col-md-6 ire-right">
            <p>
              Our Singles Socials are high-energy, large-scale mingling events
              designed to bring together 100-300 singles in a fun and social
              setting. Whether you're looking to meet someone special or just
              enjoy a great night out, these events give you the perfect
              opportunity to chat, connect, and see where the night takes you.
            </p>
            <div className="arrive">
              <Link
                to="/upcoming-events"
                className="btn bros-bu text-decoration-none"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid expand new-expa">
        <div className="row align-items-strech d-flex">
          {/* Left Side Content */}
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>HOW IT WORKS</h2>
              <h4>What to expect </h4>
            </div>
            <div className="tired-2">
              <Link
                to="/upcoming-events"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>

          {/* Right Side Features */}
          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/venu-1.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>100-300 Singles in One Room </h5>
                <p>
                  A vibrant mix of men and women, all looking to meet new
                  people.{" "}
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/venu-2.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>A True Mingling Event</h5>
                <p>
                  There’s no structured dating—it’s up to you to make the move
                  and start a conversation.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/venu-3.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Fun Icebreakers </h5>
                <p>
                  We'll provide a light, optional icebreaker to help get the
                  conversations flowing, but ultimately, it’s your night to
                  chat, connect, and have fun.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/venu-4.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Top Venues & Great Vibes </h5>
                <p>
                  Hosted in some of Ireland’s best bars and venues, with a
                  lively atmosphere perfect for meeting new people.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-6.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>No apps, no algorithms</h5>
                <p>
                  just real people meeting face-to-face. Grab a drink, join the
                  conversation, and make your move!
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex d-md-none order-4 tired-2 mt-3 text-center">
            <Link to="/contact" className="brow-bu text-decoration-none w-100">
              BROWSE EVENTS
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid real-connection new-real sparks">
        <div className="row justify-content-between">
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>YFMF</h6>
              <h2>Zero swiping, just genuine connections.</h2>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-6 pe-md-0">
            <div>
              <Slider ref={sliderRef} {...settings}>
                {images.map((img, i) => (
                  <div
                    key={i}
                    className={`custom-slide ${
                      i === images.length - 1 ? "last-slide" : ""
                    }`}
                  >
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{
                        width: "100%",
                        height: "460px",
                        borderRadius: 24,
                        objectFit: "cover",
                      }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="accors accordi good">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Good to know</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>What are Single Socials?</Accordion.Header>
                <Accordion.Body>
                  Your Friend, My Friend Single Socials / Single Parties are
                  relaxed, in - person events designed to help singles meet
                  naturally, without apps or pressure. Hosted in vibrant venues
                  across Ireland and the UK , these nights are filled with
                  conversation, good vibes, and real connection. Whether it’s a
                  BBQ, themed event or just a fun night out, our events are
                  curated for singles who are ready to meet face to face.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>How do the events work?</Accordion.Header>
                <Accordion.Body>
                  Each event is slightly di fferent, but the goal is always the
                  same: to make it easier (and more fun) for singles to connect.
                  After signing up, you’ll receive full event details. On the
                  night, our hosts will welcome you, introduce a light
                  icebreakers to get things flowing, and the r est unfolds
                  organically. No awkward set ups, just a good time with like -
                  minded people.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Who attends these events?</Accordion.Header>
                <Accordion.Body>
                  Our events attract friendly, sociable singles from all walks
                  of life. Most are professionals aged between 25 and 45 (with
                  some events tailored for specific age groups). They’re tired
                  of swiping and are ready to meet people in real life. If that
                  sounds like you, you’ll fit right in.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  Will I be matched with people at the event?
                </Accordion.Header>
                <Accordion.Body>
                  At most Single Parties , you’re free to mingle naturally,
                  there’s no form al matchmaking. However, some of our events
                  (like Speed Dating or some specific events ) include optional
                  match systems or compatibility forms. Either way, our team is
                  always there to help spark connections.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  What if I’m nervous about attending alone?
                </Accordion.Header>
                <Accordion.Body>
                  You wo n’t be the only one! Many people come solo, and our
                  hosts are brilliant at making everyone feel welcome from the
                  moment they walk in. Plus, the group atmosphere and friendly
                  crowd mean you’ll feel part of something right away.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>What should I wear?</Accordion.Header>
                <Accordion.Body>
                  Dress lik e yourself, just your slightly more polished self.
                  Most events are smart casual. Our advice is to dress like
                  you’re trying to impress someone on a first date.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  Is there an even male-to-female ratio?
                </Accordion.Header>
                <Accordion.Body>
                  We always aim for a balanced gender ratio at our events an d
                  often close ticket sales for one gender if numbers become
                  uneven. This helps ensure the best experience for everyone
                  attending.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  Do I have to participate in the icebreakers?
                </Accordion.Header>
                <Accordion.Body>
                  Nope! Icebreakers are there to help, not pressure. They’re
                  totally optional, and many people find them a great way to
                  start chatting. If you’d rather dive into conversations your
                  own way, that’s absolutely fine too.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  Are drinks and food included in the ticket?
                </Accordion.Header>
                <Accordion.Body>
                  It depends on the event. Some tickets include a welcome drink,
                  dinner or snac ks, while others are just entry. Each event
                  listing clearly states what’s included, so check the details
                  before you book.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  Do people actually meet at these events?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, constantly! We’ve seen friendships, relationships, even
                  engagements come out of our even ts. The relaxed format and
                  shared experience make it much easier to connect. You never
                  know who you might meet.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10">
                <Accordion.Header>How do I sign up?</Accordion.Header>
                <Accordion.Body>
                  Head to yourfriendmyfriend.ie and browse our upcoming events.
                  Select the one that suits you, purchase your ticket, and
                  you’re in! You’ll receive a confirmation email with all the
                  info you need.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="11">
                <Accordion.Header>Are tickets refundable?</Accordion.Header>
                <Accordion.Body>
                  Tickets are fully refundable up to 48 hours prior to the event. If you are looking to cancel within 48 hours of the event, please email hello@yourfriendmyfriend.ie and we will do our best to resell your ticket for you.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="12" className="lasty">
                <Accordion.Header>
                  How is this different from speed dating?
                </Accordion.Header>
                <Accordion.Body>
                  Single Socials are more relaxed and unstructured than Speed
                  Dating. There’s no set schedule of timed conversations, just a
                  casual environment where con nections happen more naturally.
                  If you're looking for something structured, Speed Dating is a
                  great option too, and we offer both!
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <Appqr />
      <Footer />
    </>
  );
};

export default SingleSocialsPage;
